import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import apiPainel from "../services/apiPainel";
import { conectarSocketPainel } from "../services/socketPainel";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function getBoisUI(boiAtual, totalBois) {
  const verdes = Math.max(0, Math.min(totalBois, (Number(boiAtual) || 1) - 1));
  const pretos = Math.max(0, totalBois - verdes);

  return { verdes, pretos };
}

export default function PlacarClassificacao() {
  const query = useQuery();
  const eventoId = query.get("eventoId");
  const categoria = query.get("categoria");

  const [rodizio, setRodizio] = useState(null);
  const [erro, setErro] = useState("");

  async function carregar() {
    if (!eventoId || !categoria) return;

    try {
      const { data } = await apiPainel.get(`/rodizio/estado/${eventoId}/${categoria}`);
      setRodizio(data?.rodizio || null);
      setErro("");
    } catch (e) {
      setErro(e?.response?.data?.error || e.message);
      setRodizio(null);
    }
  }

  useEffect(() => {
    carregar();

    const interval = setInterval(() => {
      carregar(); // ✅ fallback
    }, 2000);

    const socket = conectarSocketPainel();
    const channel = `rodizio:${eventoId}:${categoria}:update`;

    socket.on(channel, () => carregar());

    return () => {
      clearInterval(interval);
      socket.off(channel);
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventoId, categoria]);

  const atual = rodizio?.fila?.[0] || null;
  const proximas = rodizio?.fila?.slice(1, 4) || [];
  const boisParaClassificar = rodizio?.boisParaClassificar || 4;

  const { verdes, pretos } = useMemo(() => {
    return getBoisUI(atual?.boiAtual || 1, boisParaClassificar);
  }, [atual, boisParaClassificar]);

  // ✅ parcial por categoria (classificadas)
  const parcial = useMemo(() => {
    const map = {};

    for (const c of rodizio?.classificadas || []) {
      const cat = (c?.categoriaOriginal || categoria || "Categoria").trim();
      map[cat] = (map[cat] || 0) + 1;
    }

    // se não tiver categoriaOriginal ainda, pelo menos mostra a categoria atual
    if (!Object.keys(map).length) map[categoria] = 0;

    return map;
  }, [rodizio, categoria]);

  return (
    <div style={tela}>
      {/* TOPO */}
      <div style={topo}>
        <div style={{ fontWeight: 900, fontSize: 28, color: "#fff" }}>
          CLASSIFICAÇÃO : {categoria || "-"}
        </div>
      </div>

      {/* CONTEÚDO */}
      <div style={grid}>
        {/* ESQUERDA */}
        <div style={painelEsq}>
          <div style={tituloBarra}>SENHA DA VEZ:</div>

          {!rodizio ? (
            <div style={{ padding: 20, opacity: 0.8 }}>
              {erro ? `Erro: ${erro}` : "Rodízio não iniciado ou sem fila."}
            </div>
          ) : !atual ? (
            <div style={{ padding: 20, opacity: 0.8 }}>Sem senha na fila.</div>
          ) : (
            <>
              {/* CARD SENHA */}
              <div style={cardSenha}>
                <div style={numeroSenha}>{String(atual.numeroSenha).padStart(4, "0")}</div>

                <div style={{ flex: 1 }}>
                  <div style={nomeVaqueiro}>{(atual.nomeVaqueiro || "-").toUpperCase()}</div>

                  {/* BOIS */}
                  <div style={linhaBois}>
                    {Array.from({ length: verdes }).map((_, i) => (
                      <div key={`v-${i}`} style={{ ...boiIcon, background: "#22c55e" }} />
                    ))}
                    {Array.from({ length: pretos }).map((_, i) => (
                      <div key={`p-${i}`} style={{ ...boiIcon, background: "#111" }} />
                    ))}
                  </div>
                </div>
              </div>

              {/* PRÓXIMAS */}
              <div style={proximasBox}>
                <div style={subtitulo}>PRÓXIMAS:</div>

                {proximas.length === 0 ? (
                  <div style={{ opacity: 0.75 }}>Nenhuma próxima</div>
                ) : (
                  proximas.map((p, idx) => (
                    <div key={`${p.numeroSenha}-${idx}`} style={itemProxima}>
                      <div style={numeroPeq}>{String(p.numeroSenha).padStart(4, "0")}</div>
                      <div style={nomePeq}>{(p.nomeVaqueiro || "-").toUpperCase()}</div>
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </div>

        {/* DIREITA */}
        <div style={painelDir}>
          <div style={tituloBarra}>PARCIAL:</div>

          <div style={{ padding: 18, display: "flex", flexDirection: "column", gap: 14 }}>
            {Object.entries(parcial).map(([catNome, qtd]) => (
              <div key={catNome} style={parcialLinha}>
                <div style={parcialNumero}>{String(qtd).padStart(2, "0")}</div>
                <div style={parcialTexto}>{catNome.toUpperCase()}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* rodapé pequeno */}
      <div style={{ textAlign: "center", marginTop: 10, opacity: 0.55, fontSize: 12 }}>
        Ticket do Vaqueiro • Atualização ao vivo
      </div>
    </div>
  );
}

const tela = {
  background: "radial-gradient(circle at top, #2b2b2b 0%, #111 70%)",
  minHeight: "100vh",
  padding: 18,
  boxSizing: "border-box",
};

const topo = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: 70,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "1.5fr 1fr",
  gap: 18,
};

const painelEsq = {
  borderRadius: 20,
  border: "2px solid rgba(255,255,255,.15)",
  padding: 16,
};

const painelDir = {
  borderRadius: 20,
  border: "2px solid rgba(255,255,255,.15)",
  padding: 16,
};

const tituloBarra = {
  width: "fit-content",
  padding: "10px 18px",
  borderRadius: 12,
  background: "#fdd212",
  color: "#111",
  fontWeight: 900,
  fontSize: 22,
  marginBottom: 14,
};

const cardSenha = {
  display: "flex",
  gap: 14,
  alignItems: "center",
  background: "#ffeb00",
  borderRadius: 20,
  padding: 16,
};

const numeroSenha = {
  background: "#111",
  color: "#fff",
  fontWeight: 900,
  fontSize: 44,
  borderRadius: 18,
  padding: "18px 22px",
  minWidth: 120,
  textAlign: "center",
};

const nomeVaqueiro = {
  fontSize: 48,
  fontWeight: 900,
  color: "#2b2b2b",
  lineHeight: 1,
};

const linhaBois = {
  display: "flex",
  gap: 10,
  marginTop: 12,
};

const boiIcon = {
  width: 42,
  height: 26,
  borderRadius: 8,
  border: "2px solid rgba(0,0,0,.25)",
};

const proximasBox = {
  marginTop: 16,
  background: "rgba(0,0,0,.35)",
  borderRadius: 18,
  padding: 14,
  border: "1px solid rgba(255,255,255,.1)",
};

const subtitulo = {
  fontSize: 26,
  fontWeight: 900,
  marginBottom: 10,
};

const itemProxima = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  background: "rgba(255,255,255,.05)",
  borderRadius: 16,
  padding: "10px 12px",
  marginBottom: 10,
};

const numeroPeq = {
  background: "#ffeb00",
  color: "#111",
  fontWeight: 900,
  fontSize: 22,
  borderRadius: 14,
  padding: "10px 14px",
  minWidth: 72,
  textAlign: "center",
};

const nomePeq = {
  color: "#fff",
  fontSize: 26,
  fontWeight: 900,
};

const parcialLinha = {
  display: "flex",
  alignItems: "center",
  gap: 14,
  background: "rgba(255,255,255,.05)",
  borderRadius: 18,
  padding: "12px 14px",
  border: "1px solid rgba(255,255,255,.08)",
};

const parcialNumero = {
  background: "#fdd212",
  color: "#111",
  fontWeight: 900,
  fontSize: 38,
  borderRadius: 18,
  padding: "8px 16px",
  minWidth: 90,
  textAlign: "center",
};

const parcialTexto = {
  color: "#fff",
  fontWeight: 900,
  fontSize: 28,
};
